export const getConfig = store => (store.config ? store.config : {});
export const isConfigLoaded = store => {
  let config = getConfig(store);
  return config.loaded != null && config.loaded;
};
export const getLogo = store => getConfig(store).logo;
export const getMenu = store => getConfig(store).menu;
